
// auth0-js needs to be in global scope for angular-auth0 to access it.
// Typescript does not allow module added to the global scope.
window.auth0 = window.Auth0 = require('auth0-js');
